"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The InvoicePayment model module.
 * @module model/InvoicePayment
 * @version 3.0
 */
var InvoicePayment = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>InvoicePayment</code>.
   * @alias module:model/InvoicePayment
   */
  function InvoicePayment() {
    _classCallCheck(this, InvoicePayment);
    InvoicePayment.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(InvoicePayment, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>InvoicePayment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvoicePayment} obj Optional instance to populate.
     * @return {module:model/InvoicePayment} The populated <code>InvoicePayment</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new InvoicePayment();
        if (data.hasOwnProperty('invoicePaymentId')) {
          obj['invoicePaymentId'] = _ApiClient["default"].convertToType(data['invoicePaymentId'], 'Number');
        }
        if (data.hasOwnProperty('paymentLegacyId')) {
          obj['paymentLegacyId'] = _ApiClient["default"].convertToType(data['paymentLegacyId'], 'String');
        }
        if (data.hasOwnProperty('paymentDate')) {
          obj['paymentDate'] = _ApiClient["default"].convertToType(data['paymentDate'], 'Date');
        }
        if (data.hasOwnProperty('subTotal')) {
          obj['subTotal'] = _ApiClient["default"].convertToType(data['subTotal'], 'Number');
        }
        if (data.hasOwnProperty('total')) {
          obj['total'] = _ApiClient["default"].convertToType(data['total'], 'Number');
        }
        if (data.hasOwnProperty('vat')) {
          obj['vat'] = _ApiClient["default"].convertToType(data['vat'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('units')) {
          obj['units'] = _ApiClient["default"].convertToType(data['units'], 'String');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvoicePayment</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvoicePayment</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['paymentLegacyId'] && !(typeof data['paymentLegacyId'] === 'string' || data['paymentLegacyId'] instanceof String)) {
        throw new Error("Expected the field `paymentLegacyId` to be a primitive type in the JSON string but got " + data['paymentLegacyId']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['units'] && !(typeof data['units'] === 'string' || data['units'] instanceof String)) {
        throw new Error("Expected the field `units` to be a primitive type in the JSON string but got " + data['units']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} invoicePaymentId
 */
InvoicePayment.prototype['invoicePaymentId'] = undefined;

/**
 * @member {String} paymentLegacyId
 */
InvoicePayment.prototype['paymentLegacyId'] = undefined;

/**
 * @member {Date} paymentDate
 */
InvoicePayment.prototype['paymentDate'] = undefined;

/**
 * @member {Number} subTotal
 */
InvoicePayment.prototype['subTotal'] = undefined;

/**
 * @member {Number} total
 */
InvoicePayment.prototype['total'] = undefined;

/**
 * @member {Number} vat
 */
InvoicePayment.prototype['vat'] = undefined;

/**
 * @member {String} currency
 */
InvoicePayment.prototype['currency'] = undefined;

/**
 * @member {String} units
 */
InvoicePayment.prototype['units'] = undefined;

/**
 * @member {String} message
 */
InvoicePayment.prototype['message'] = undefined;
var _default = exports["default"] = InvoicePayment;